// Performance directions are not spoken text. Preserve mathematical brackets.
const cuePattern = /\[(?:pause|long pause|sighs|exhales|clears throat|laughs|chuckles|curious|thoughtful|excited)\]/gi;

export function spokenNarration(script: string) {
  return script.replace(cuePattern, ' ').replace(/[ \t]+/g, ' ').replace(/ *\n */g, '\n').trim();
}

export function estimatedPerformancePauses(script: string) {
  return [...script.matchAll(/\[(pause|long pause)\]/gi)]
    .reduce((seconds, match) => seconds + (match[1].toLowerCase() === 'long pause' ? 2.5 : 0.8), 0);
}